export const featuredStories = [
  {
    id: 'f1',
    badge: '正在发酵',
    category: '明星八卦',
    title: '深夜聚餐路透照流出，同框细节被逐帧放大解读',
    summary:
      '多位网友在不同时段拍到的同框画面被整理成时间线，从餐厅门口到停车场，事件脉络逐渐清晰，相关话题阅读量持续走高。',
    heat: '热度 26.8 万',
    comments: 1284,
    cover:
      'https://readdy.ai/api/search-image?query=stylized%20abstract%20entertainment%20news%20hero%20background%20with%20glowing%20stage%20spotlights%20and%20floating%20film%20reels%2C%20scattered%20popcorn%20and%20torn%20magazine%20clippings%2C%20deep%20crimson%20and%20amber%20color%20palette%2C%20cinematic%20rim%20lighting%2C%20layered%20paper%20collage%20texture%2C%20editorial%20art%20direction%2C%20moody%20atmosphere%2C%20no%20people&width=1000&height=700&seq=hl-hero-main-01&orientation=landscape',
  },
  {
    id: 'f2',
    badge: '最新投稿',
    category: '娱乐瓜',
    title: '综艺录制现场花絮外泄，嘉宾临场反应成讨论焦点',
    summary: '三段现场素材在整理后被拼接，节目组的剪辑取舍成为新的话题。',
    heat: '热度 11.2 万',
    comments: 736,
    cover:
      'https://readdy.ai/api/search-image?query=stylized%20abstract%20collage%20of%20vintage%20clapperboard%20and%20scattered%20popcorn%20over%20warm%20crimson%20amber%20backdrop%2C%20paper%20cutout%20texture%2C%20soft%20dramatic%20lighting%2C%20editorial%20art%20direction%2C%20high%20detail%2C%20no%20people&width=640&height=480&seq=hl-hero-side-01&orientation=landscape',
  },
  {
    id: 'f3',
    badge: '素人线索',
    category: '素人爆料',
    title: '网友投稿剧组探班目击，后台细节被完整记录',
    summary: '投稿者提供了一组现场照片与时间说明，评论区正在比对细节。',
    heat: '热度 8.6 万',
    comments: 412,
    cover:
      'https://readdy.ai/api/search-image?query=stylized%20abstract%20collage%20of%20sealed%20envelope%20and%20studio%20microphone%20on%20warm%20crimson%20amber%20background%2C%20paper%20texture%20layers%2C%20moody%20editorial%20lighting%2C%20high%20detail%2C%20no%20people&width=640&height=480&seq=hl-hero-side-02&orientation=landscape',
  },
];